export default __webpack_public_path__ + "static/media/t17.min.17ef29b5.png";